import cd from 'debug';
import core, { GQL } from '@gin-betting/core';

import getMatchStatusesByLocation from './getMatchStatusesByLocation';
import getMarketStatusesByLocation from './getMarketStatusesByLocation';
import getSportEventTypesByLocation from './getSportEventTypesByLocation';

const { getBettingOptions, getAppliedFilters } = core.utils;

const debug = cd('app:utils:getDefaultVariables');

export default function getDefaultVariablesFavorite(): GQL.GetMatchesByFiltersQueryVariables {
    const { sportIds, tournamentIds = [] } = getBettingOptions();
    const matchStatuses = getMatchStatusesByLocation();
    const marketStatuses = getMarketStatusesByLocation();
    const sportEventTypes = getSportEventTypesByLocation();
    const filters = getAppliedFilters();

    const defaultVariables = {
        marketStatuses,
        matchStatuses,
        sportEventTypes,
        sportIds,
        tournamentIds,
    };

    const extendedVariables: {
        dateSortAscending?: false;
        dateFrom?: string;
        withMarketsCount?: false;
    } = {};

    const result: GQL.GetMatchesByFiltersQueryVariables = {
        offset: 0,
        limit: 100,
        ...defaultVariables,
        ...extendedVariables,
        // TODO: remove type casting, hardcode
        ...(filters as Omit<typeof filters, 'freeBetId'>),
    };

    debug('result', result);

    return result;
}
